import { getCdnToken } from './emoji-upload'
import { getCdnUploadToken } from './cdn'

let cos
let tokenInfo = {}


function getCos () {
  return new Promise((resolve, reject) => {
    import('cos-js-sdk-v5').then((COSModule) => {
      let COS = COSModule.default
      cos = new COS({
        getAuthorization: (options, callback) => {
          callback({
            TmpSecretId: tokenInfo.credentials.tmpSecretId,
            TmpSecretKey: tokenInfo.credentials.tmpSecretKey,
            XCosSecurityToken: tokenInfo.credentials.sessionToken,
            StartTime: tokenInfo.startTime,
            ExpiredTime: tokenInfo.expiredTime,
          })
        }
      })
      resolve()
    }).catch(() => {
      reject()
    })
  })
}

export function getCustomCDNTokenInfo ({type, source, scope = 'chat'}, upload_infos) {
  const data = {
    type,
    source,
    scope,
    file_infos: JSON.stringify(upload_infos),
  }
  return getCdnToken({}, data)
}

export function uploadToCustomCDN (files, type, config, cb, errorCb, progressCb, all_complete_cb) {
  tokenInfo = config.token
  let result = new Array(files.length)
  files.forEach(({ file_info }, index) => {
    let { file, path, key } = file_info
    let baseInfo = {
      Bucket: config.bucket, /* 必须 */
      Region: 'ap-shanghai', /* 存储桶所在地域，必须字段 */
      Key: key, /* 必须 */
      Headers: {},
    }
    if (type === 'file') {
      baseInfo.ContentDisposition = `attachment;filename=${encodeURIComponent(file.name)}`
    }
    getCos().then(() => {
      console.log('xxxxxxx start putObject')
      cos.putObject({
        ...baseInfo,
        Body: file, /* 必须 */
        ACL: config.ACL,
        onTaskReady: (taskId) => {},
        onHashProgress: (progressData) => {},
        onProgress: (progressData) => { /* 非必须 */
          if (progressCb) {
            progressCb(progressData)
          }
        }
      }, (err, data) => {
        console.log(err, data)
        result[index] = { err, data }
        if (!err && data.statusCode === 200) {
          var url = `https://${config.host + key}`;
          cb(path, url)
          result[index].path = path
          result[index].url = url
        } else {
          if (errorCb) {
            errorCb(err, data)
          }
        }
        if (!result.includes(undefined)) {
          all_complete_cb && all_complete_cb(result)
        }
      })
    })
  });

}
